module.exports = __webpack_public_path__ + "img/m8.84bbed4d.png";